import ThumbUpIcon from '@heroicons/react/outline/esm/ThumbUpIcon.js'
import ChevronUpIcon from '@heroicons/react/solid/esm/ChevronUpIcon.js'

import { Post, ReactionType } from '@tribeplatform/gql-client/types'

import { useI18n, useStaticIntl } from '../../i18n/index.js'
import { I18nShape } from '../../i18n/types.js'
import { SingleReaction } from './SingleReaction.js'
import { SingleReactionWithOptions } from './SingleReactionWithOptions.js'

const reactionsFactory = ({ $t }: I18nShape) => ({
  '+1': $t({ defaultMessage: 'Like', id: 'Generics.Like.Verb' }),
  heart: $t({ defaultMessage: 'Love', id: 'Generics.Love.Verb' }),
  tada: $t({ defaultMessage: 'Celebrate', id: 'Generics.Celebrate.Verb' }),
  smile: $t({ defaultMessage: 'Smile', id: 'Generics.Smile.Verb' }),
  open_mouth: $t({ defaultMessage: 'Wow!', id: 'Generics.WowBang' }),
  cry: $t({ defaultMessage: 'Cry', id: 'Generics.Cry.Verb' }),
})

interface Props {
  post: Post
  showIcon?: boolean
  showText?: boolean
}
export const LikeAction = ({
  post,
  showIcon = true,
  showText = true,
}: Props) => {
  const { $t } = useI18n()
  const reactions = useStaticIntl(reactionsFactory)
  switch (post?.primaryReactionType) {
    case ReactionType.VOTE_BASE:
      return (
        <SingleReaction
          post={post}
          text={
            showText
              ? $t({
                  id: 'Generics.Upvote',
                  defaultMessage: 'Upvote',
                })
              : ''
          }
          showCount={!showText}
          reaction="+1"
          Icon={showIcon ? <ChevronUpIcon /> : null}
        />
      )
    case ReactionType.LIKE_BASE:
      return (
        <SingleReaction
          post={post}
          text={
            showText
              ? $t({ defaultMessage: 'Like', id: 'Generics.Like.Verb' })
              : ''
          }
          reaction="+1"
          Icon={showIcon ? <ThumbUpIcon /> : null}
        />
      )
    case ReactionType.EMOJI_BASE:
      return (
        <SingleReactionWithOptions
          post={post}
          mainReaction="+1"
          mainReactionText={$t({
            defaultMessage: 'Like',
            id: 'Generics.Like.Verb',
          })}
          options={reactions}
          showIcon={showIcon}
          showText={showText}
        />
      )
    default:
      return null
  }
}
